import { ROUTES } from "@/app/routes";

interface DefaultRouteParams {
	isPlatformAdmin: boolean;
	isInvestorOnly: boolean;
}

export function getDefaultRoute({
	isPlatformAdmin,
	isInvestorOnly,
}: DefaultRouteParams): string {
	if (isPlatformAdmin) return ROUTES.ADMIN.DASHBOARD;
	if (isInvestorOnly) return ROUTES.HUB.DASHBOARD;
	return ROUTES.DASHBOARD;
}
